import { Checkbox, Modal } from "antd";
import { whatsappIcon } from "../../assets/images";
import { UiButton, UiTab, UiTextArea, UiTextBox } from "..";
import { messageTabData } from "../complaints/config";

const SendMessageModal = ({
    open,
    onClose,
    onSubmit,
    handleMessageChange,
    handleMessageTabChange,
    messageData,
    handleMessageCheck,
    isButtonLoading,
    showWhatsapp = true
}) => {
    const isWarningMessage = messageData?.warning;
    const isRaisedByCustomer = messageData?.complaintType === "COMPLAINT_RAISED_CUSTOMER";
    const raisedByLabel = isRaisedByCustomer ? "Customer" : "Lawyer";
    const againstByLabel = isRaisedByCustomer ? "Lawyer" : "Customer";
    const tabs = messageTabData?.map(tab => ({
        ...tab,
        label: tab?.content === "raised" ? raisedByLabel : (tab?.content === "against" ? againstByLabel : tab?.label)
    }));

    const isButtonEnable = messageData?.isButtonEnable !== undefined
        ? messageData?.isButtonEnable
        : Boolean(messageData?.subject && messageData?.body && (messageData?.isWhatsapp || (messageData?.isMail ?? true)));

    return (
        <Modal
            open={open}
            onCancel={onClose}
            title={isWarningMessage ? "Send Warning Message" : "Send Message"}
            footer={
                <UiButton loading={isButtonLoading} type="primary" onClick={onSubmit} style={{ pointerEvents: isButtonEnable ? "" : "none" }}>
                    {isWarningMessage ? "Send Warning Message" : "Send Message"}
                </UiButton>
            }
        >
            <UiTab tabs={tabs} onChange={handleMessageTabChange} activeTabKey={messageData?.activeTabKey} noBadge />
            <div>
                <p>
                    {isWarningMessage
                        ? "Are You Sure You Want to send The Warning Message"
                        : "Are You Sure You Want to send The Message"}
                </p>

                <div style={{ color: "#005D60", fontWeight: 500, fontSize: "14px" }}>
                    <UiTextBox value={messageData?.subject} required name="subject" label="Subject" maxLength={50} onChange={(message) => handleMessageChange(message?.target?.value, "subject")} />
                </div>
                <div style={{ color: "#005D60", fontWeight: 500, fontSize: "14px" }}>
                    <UiTextArea value={messageData?.body} required name="body" label="Type Message" maxLength={150} onChange={(message) => handleMessageChange(message?.target?.value, "body")} />
                </div>
            </div>
            {showWhatsapp && (
                <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "0px 10px" }}>
                    <Checkbox checked={messageData?.isWhatsapp} onChange={(check) => handleMessageCheck(check?.target?.checked, "whatsapp")}>
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                margin: "10px 0px",
                            }}
                        >
                            <img
                                src={whatsappIcon}
                                alt=""
                                style={{ width: 20, height: 20 }}
                            />
                            Whatsapp
                        </span>
                    </Checkbox>
                </div>
            )}
            <div style={{ padding: "0px 10px" }}>
                <Checkbox checked={messageData?.warning} onChange={(check) => handleMessageCheck(check?.target?.checked, "warning")}>
                    <span style={{ color: "#666" }}>Check this box to include warning counts.</span>
                </Checkbox>
            </div>
        </Modal>
    );
};

export default SendMessageModal;
